import React, { Component } from 'react';

import {
    Modal, Form, Input, InputNumber, DatePicker, Icon,
} from 'antd';

import moment from 'moment';

const FormItem = Form.Item;


class UnwrappedAddNonRxMedicineModal extends Component {
    getTotalCount = () => {
        console.log('lola');
        const { form } = this.props;
        const { getFieldValue } = form;

        if (isNaN(getFieldValue('non_prescription_medicine_strip')) && isNaN(getFieldValue('non_prescription_medicine_per_strip'))) {
            return 0;
        }
        return Number(getFieldValue('non_prescription_medicine_strip')) * Number(getFieldValue('non_prescription_medicine_per_strip')) + Number(getFieldValue('non_prescription_medicine_extra_pill'));
    }

    render() {
        const {
            visible, onCancel, onCreate, data, confirmLoading, form, selectedMed,
        } = this.props;

        console.log(selectedMed);
        const medName = selectedMed == null ? '' : selectedMed.split('#')[1];
        const medForm = selectedMed == null ? '' : selectedMed.split('#')[4];

        const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 15 },
            },
        };

        const addPills = (
            <Icon
                type="plus"
                onClick={() => {
                    setFieldsValue({ total_quantity: Number(getFieldValue('total_quantity')) + 1 });
                }}
            />
        );
        const removePills = (
            <Icon
                type="minus"
                onClick={() => {
                    setFieldsValue({ total_quantity: Number(getFieldValue('total_quantity')) - 1 });
                }}
            />
        );

        return (
            <Modal
                visible={visible}
                title="Add Medicine Details"
                style={{ textAlign: 'center', fontSize: '1.2em', top: 40 }}
                okText="Submit"
                confirmLoading={confirmLoading}
                onCancel={onCancel}
                onOk={onCreate}
            >

                <Form>

                    <div style={{ height: '580px', overflow: 'auto' }}>
                        <FormItem
                            {...formItemLayout}
                            label="Name"
                        >
                            {getFieldDecorator('med_name', {
                                rules: [{ required: true }],
                                initialValue: Object.keys(data).length > 0 ? data.med_name : medName,
                            })(
                                <Input disabled />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Form"
                        >
                            {getFieldDecorator('non_prescription_medicine_form', {
                                rules: [{ required: true }],
                                initialValue: Object.keys(data).length > 0 ? data.non_prescription_medicine_form : medForm,
                            })(
                                <Input disabled />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Start Date"
                        >
                            {getFieldDecorator('non_prescription_medicine_start_date', {
                                rules: [{ required: true, message: 'Start date is important' }],
                                initialValue: data.non_prescription_medicine_start_date == null ? null : moment(data.non_prescription_medicine_start_date),
                            })(
                                <DatePicker
                                    style={{ width: '100%' }}
                                />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Duration"
                        >

                            {getFieldDecorator('duration', {
                                rules: [{ required: true, message: 'How long the medicine will run?' }],
                                initialValue: '',
                            })(
                                <InputNumber style={{ width: '100%' }} />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Strip/Unit"
                        >

                            {getFieldDecorator('non_prescription_medicine_strip', {
                                rules: [{ required: false, message: 'How long the medicine will run?' }],
                                initialValue: data.non_prescription_medicine_strip == null ? '' : data.non_prescription_medicine_strip,
                            })(
                                <InputNumber style={{ width: '100%' }} />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Per Strip/Unit"
                        >

                            {getFieldDecorator('non_prescription_medicine_per_strip', {
                                rules: [{ required: false, message: 'How long the medicine will run?' }],
                                initialValue: data.non_prescription_medicine_per_strip == null ? '' : data.non_prescription_medicine_per_strip,
                            })(
                                <InputNumber style={{ width: '100%' }} />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Extra Pill/Unit"
                        >

                            {getFieldDecorator('non_prescription_medicine_extra_pill', {
                                rules: [{ required: false, message: 'How long the medicine will run?' }],
                                initialValue: data.non_prescription_medicine_extra_pill == null ? '' : data.non_prescription_medicine_extra_pill,
                            })(
                                <InputNumber style={{ width: '100%' }} />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Total Quantity"
                        >

                            {getFieldDecorator('non_prescription_medicine_total_quantity', {
                                rules: [{ required: true, message: 'Total value is needed!' }],
                                initialValue: data.non_prescription_medicine_total_quantity == null ? this.getTotalCount() : data.non_prescription_medicine_total_quantity,
                            })(
                                <Input min={0} style={{ width: '150', textAlign: 'center' }} addonBefore={removePills} addonAfter={addPills} />,
                            )}
                        </FormItem>

                    </div>

                </Form>

            </Modal>
        );
    }
}

const AddNonRxMedicineModal = Form.create()(UnwrappedAddNonRxMedicineModal);

export default AddNonRxMedicineModal;



// WEBPACK FOOTER //
// ./src/component/AddingNonRxMedicines/AddNonRxMedicineModel.js